(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["genki-skin-ritual"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('genki-skin-ritual')) {
    customElements.define(
      'genki-skin-ritual',
      class extends HTMLElement {
        connectedCallback() {
          if (this.dataset.ready === 'true') return;
          this.dataset.ready = 'true';
          this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
          this.steps = Array.from(this.querySelectorAll('[data-ritual-step]'));
          this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
          this.media = Array.from(this.querySelectorAll('[data-ritual-media]'));

          this.tabs.forEach((tab, index) => {
            tab.addEventListener('click', () => this.activate(index));
            tab.addEventListener('keydown', (event) => this.onKeydown(event, index));
          });
        }

        activate(index, moveFocus = false) {
          this.tabs.forEach((tab, tabIndex) => {
            const active = tabIndex === index;
            tab.setAttribute('aria-selected', active ? 'true' : 'false');
            tab.tabIndex = active ? 0 : -1;
            this.steps[tabIndex]?.classList.toggle('is-active', active);
            if (this.panels[tabIndex]) this.panels[tabIndex].hidden = !active;
            if (this.media[tabIndex]) {
              this.media[tabIndex].classList.toggle('is-active', active);
              this.media[tabIndex].setAttribute('aria-hidden', active ? 'false' : 'true');
            }
          });
          if (moveFocus) this.tabs[index]?.focus();
        }

        onKeydown(event, index) {
          let nextIndex = index;
          if (event.key === 'ArrowDown' || event.key === 'ArrowRight') nextIndex = (index + 1) % this.tabs.length;
          if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') nextIndex = (index - 1 + this.tabs.length) % this.tabs.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = this.tabs.length - 1;
          if (nextIndex === index) return;
          event.preventDefault();
          this.activate(nextIndex, true);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
